import React from 'react';
import { IonText } from '@ionic/react';
import { useSelector } from 'react-redux';
import { IState } from 'appRedux/createStore';
import { shouldShowPop } from 'lib/showPop';
import { ICasinoReport } from 'appRedux/models/casinoModels';
import SectionHeader from './SectionHeader';
import {
  mapCasinoReportToGameInfo,
  type GameInformationProps,
} from './mapCasinoReportToGameInfo';
// import './GameInformation.scss';

export type { GameInformationProps };
export { mapCasinoReportToGameInfo };

interface GameCasinoReport {
  casinoReport: ICasinoReport;
}

const GameInformation: React.FC<GameCasinoReport> = ({ casinoReport }) => {
  const gameInfoProps: GameInformationProps = mapCasinoReportToGameInfo(casinoReport);
  // POP row only when the current casino has showPOP = 1 (hidden by default).
  const showPop = useSelector((state: IState) =>
    shouldShowPop(state.app.persistedState.casinoSchema)
  );

  return (
    <>
      <div className="game-info-card">
        <SectionHeader title="Game Info" showRow={true} rotateDisabled={true} iconName="info"/>

        <div className="game-details">
          <div className="info-row">
            <IonText color="medium">Manufacturer</IonText>
            <IonText>{gameInfoProps.manufacturer}</IonText>
          </div>
          <div className="info-row">
            <IonText color="medium">Bank</IonText>
            <IonText>{gameInfoProps.bank}</IonText>
          </div>
          <div className="info-row">
            <IonText color="medium">Slot</IonText>
            <IonText>{gameInfoProps.slotNumber}</IonText>
          </div>
          {gameInfoProps.type && (
            <div className="info-row">
              <IonText color="medium">Type</IonText>
              <IonText>{gameInfoProps.type}</IonText>
            </div>
          )}
          {showPop && (
            <div className="info-row">
              <IonText color="medium">POP</IonText>
              <IonText>{gameInfoProps.pop}</IonText>
            </div>
          )}
          <div className="info-row">
            <IonText color="medium">Volatility</IonText>
            <IonText>{gameInfoProps.volatility}</IonText>
          </div>
          <div className="info-row">
            <IonText color="medium">Denom</IonText>
            <IonText>{gameInfoProps.denom}</IonText>
          </div>
        </div>

        {/* <hr /> */}

        {/* <div className="info-row rating-row">
          <IonText className="label">RATINGS</IonText>
          <IonText className="value">{rating}</IonText>
        </div> */}
      </div>
      <div style={{ height: '24px' }} />
      <div style={{ height: '24px' }} />
    </>
  );
};

export default GameInformation;
